import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BranchesPageHeader from '../../components/BranchesPageHeader';
import {
  fetchBranchDetailsForUserDispatch,
  fetchBranchDetailsByBranchIdDispatch,
  openChangePasswordDialogDispatch,
  setLoggedInUserDispatch
} from '../../actions';

const mapStateToProps = (state, ownProps) => {
  return {
    userFromDb: state.users.user.item,
    branch: state.branch.branch.item,
    isSavingEvent: state.event.newEvent.isSaving,
    isLoadingRecordsForTheEvent: state.event.recordsForTheEvent.isLoading,
    isDeletingRecord: state.event.deleteRecord.isSaving,
    isSavingNewRecord: state.event.newRecord.isSaving,
    isSavingCourse: state.course.newCourse.isSaving,
    isLoadingRecordsForTheCourse: state.course.recordsForTheCourse.isLoading,
    isDeletingCourseRecord: state.course.deleteRecord.isSaving,
    isLoadingCourses: state.courses.coursesByBranch.isLoading,
    isLoadingPersonnels: state.personnels.allPersonnels.isLoading,
    isLoadingEvents: state.events.eventsByBranch.isLoading,
    isLoadingAccidents: state.accidents.accidentsByBranch.isLoading
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchBranchDetailsForUser: (userId) => {
      dispatch(fetchBranchDetailsForUserDispatch(userId));
    },
    onChangePassword: () => {
      dispatch(openChangePasswordDialogDispatch(true));
    },
    fetchBranchDetailsByBranchId: (branchId) => {
      dispatch(fetchBranchDetailsByBranchIdDispatch(branchId));
    },
    setLoggedInUser: (user) => {
      dispatch(setLoggedInUserDispatch(user));
    }
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BranchesPageHeader)
);
